export default __webpack_public_path__ + "static/exterior_b-64d18eafd9b30d1be97dd3d0b586bd7b.jpg";